import { NgModule, ModuleWithProviders, InjectionToken } from '@angular/core';
import { VaelsysWebrtcLibComponent } from './vaelsys-webrtc-lib.component';
import { WebrtcDeviceViewComponent, PTZCommand } from './webrtc-device-view/webrtc-device-view.component';
import { HttpClientModule } from '@angular/common/http';
import { IonicModule } from '@ionic/angular';
import { VaelsysWebrtcLibService } from './vaelsys-webrtc-lib.service';
import { CommonModule } from '@angular/common';

export interface IceServer {
  urls: string | string[];
  username?: string;
  credential?: string;
};

export interface LibConfig {
  apiUrl: string;
  wsUrl: string;
  wsRealm: string;
  iceServers? : IceServer[];
}

export const LibConfigService = new InjectionToken<LibConfig>('LibConfig');


@NgModule({
  declarations: [
    VaelsysWebrtcLibComponent,
    WebrtcDeviceViewComponent
  ],
  imports: [
    CommonModule,
    IonicModule,
    HttpClientModule
  ],
  exports: [
    VaelsysWebrtcLibComponent,
    WebrtcDeviceViewComponent
  ]
})
export class VaelsysWebrtcLibModule {
  static forRoot(config: LibConfig): ModuleWithProviders<VaelsysWebrtcLibModule> {
    return {
      ngModule: VaelsysWebrtcLibModule,
      providers: [
        VaelsysWebrtcLibService,
        {
          provide: LibConfigService,
          useValue: config
        }
      ]
    };
  }
}
